import { computed, observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { Model, type ModelProps } from '@/infra/model'
import { asAtom } from '@/utils/mobx-util'
import { clock } from '@/utils/rx-util'

export type TxfJobProps = ModelProps<TxfJob>

export default class TxfJob extends Model<TxfJob> {
  /**
   * The current time as an observable.
   */
  private readonly _now = asAtom(clock('minute'), () => new Date())

  jobId: Id = Id.none

  @observable accessor createdAt: Date = unixEpoch()
  @observable accessor modifiedAt: Date = unixEpoch()
  @observable.struct accessor onboardingState: OnboardingState =
    OnboardingState.none

  @computed
  get isReadyToOnboard() {
    if (this.onboardingState.readyToOnboard) {
      return true
    }

    if (this.onboardingState.inactivityGracePeriodExpiresAt) {
      return this.onboardingState.inactivityGracePeriodExpiresAt < this._now()
    }

    return false
  }
}

interface OnboardingState {
  readonly readyToOnboard: boolean
  readonly inactivityGracePeriodExpiresAt?: Date
}

const OnboardingState = {
  none: {
    readyToOnboard: false,
    inactivityGracePeriodExpiresAt: undefined,
  } satisfies OnboardingState,
}
